import { CoreAttributes } from "./core-attributes";
/**
 * Implementation of a LocalizationContext as a heterogeneous map of "attributes".
 * <p>
 * Each attribute is identified by an {@link AttributeKey} whose type parameter enforces (at compile-time) the type
 * of the attribute's value.
 * <p>
 * This allows new attributes to be added without modifying the {@link LocalizationContext} interface, as the new
 * attributes can be accessed via the getAttribute method.
 */
export class AttributesMapLocalizationContext {
    constructor(_attributes) {
        this._attributes = _attributes;
    }
    getAttribute(attributeKey) {
        return this._attributes.get(attributeKey);
    }
    asAttributesMap() {
        const attributeMap = new Map();
        for (const key of this._attributes.keys()) {
            attributeMap.set(key.asString(), this._attributes.get(key));
        }
        return attributeMap;
    }
    getDefaultLocale() {
        return this.getAttribute(CoreAttributes.DEFAULT_LOCALE_KEY);
    }
    getI18nDomain() {
        return this.getAttribute(CoreAttributes.I18N_DOMAIN_KEY);
    }
    getLocale() {
        return this.getAttribute(CoreAttributes.LOCALE_KEY);
    }
    getTimeZone() {
        return this.getAttribute(CoreAttributes.TIME_ZONE_KEY);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXR0cmlidXRlcy1tYXAtbG9jYWxpemF0aW9uLWNvbnRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXR0cmlidXRlcy9hdHRyaWJ1dGVzLW1hcC1sb2NhbGl6YXRpb24tY29udGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFFbkQ7Ozs7Ozs7O0dBUUc7QUFDSCxNQUFNLE9BQU8sZ0NBQWdDO0lBRXpDLFlBQW9CLFdBQXdDO1FBQXhDLGdCQUFXLEdBQVgsV0FBVyxDQUE2QjtJQUFJLENBQUM7SUFFakUsWUFBWSxDQUFJLFlBQTZCO1FBQ3pDLE9BQU8sSUFBSSxDQUFDLFdBQVcsQ0FBQyxHQUFHLENBQUMsWUFBWSxDQUFDLENBQUM7SUFDOUMsQ0FBQztJQUVELGVBQWU7UUFDWCxNQUFNLFlBQVksR0FBb0MsSUFBSSxHQUFHLEVBQWUsQ0FBQztRQUM3RSxLQUFLLE1BQU0sR0FBRyxJQUFJLElBQUksQ0FBQyxXQUFXLENBQUMsSUFBSSxFQUFFLEVBQUU7WUFDdkMsWUFBWSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsUUFBUSxFQUFFLEVBQUUsSUFBSSxDQUFDLFdBQVcsQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztTQUMvRDtRQUNELE9BQU8sWUFBWSxDQUFDO0lBQ3hCLENBQUM7SUFFRCxnQkFBZ0I7UUFDWixPQUFPLElBQUksQ0FBQyxZQUFZLENBQVMsY0FBYyxDQUFDLGtCQUFrQixDQUFDLENBQUM7SUFDeEUsQ0FBQztJQUVELGFBQWE7UUFDVCxPQUFPLElBQUksQ0FBQyxZQUFZLENBQVMsY0FBYyxDQUFDLGVBQWUsQ0FBRSxDQUFDO0lBQ3RFLENBQUM7SUFFRCxTQUFTO1FBQ0wsT0FBTyxJQUFJLENBQUMsWUFBWSxDQUFTLGNBQWMsQ0FBQyxVQUFVLENBQUUsQ0FBQztJQUNqRSxDQUFDO0lBRUQsV0FBVztRQUNQLE9BQU8sSUFBSSxDQUFDLFlBQVksQ0FBUyxjQUFjLENBQUMsYUFBYSxDQUFFLENBQUM7SUFDcEUsQ0FBQztDQUNKIn0=